import axios from 'axios';
import { useAuthStore } from './auth.store';
export const baseUrl = process.env.API_BASE_URL;
// Shared axios instance for auth endpoints (login/logout/refresh/forgot/reset/change).
// withCredentials lets the browser send/receive the HttpOnly refresh-token cookie.
// Deliberately has NO interceptors — auth calls handle their own errors and must
// never trigger the app-level 401 refresh-retry loop.
export const authAxios = axios.create({
    baseURL: baseUrl,
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
});
// Single-flight guard: concurrent 401s must share one refresh call, because
// refresh tokens are single-use — a second parallel refresh would get rejected
// and log the user out.
let refreshPromise = null;
export const refreshAccessToken = () => {
    if (!refreshPromise) {
        refreshPromise = (async () => {
            try {
                const { refreshToken, user: currentUser } = useAuthStore.getState();
                if (!refreshToken || !currentUser)
                    return false;
                const res = await authAxios.post('user-manager/auth/refresh', { refresh_token: refreshToken });
                const payload = res.data.messages?.[0];
                if (!payload?.access_token)
                    return false;
                // Single-use rotation: store the new refresh token immediately.
                useAuthStore.getState().setAuth(payload.access_token, payload.expires_at, currentUser, payload.refresh_token);
                return true;
            }
            catch {
                return false;
            }
            finally {
                refreshPromise = null;
            }
        })();
    }
    return refreshPromise;
};
export const redirectToLoginAsExpired = () => {
    useAuthStore.getState().clearAuth();
    sessionStorage.setItem('sessionExpired', 'true');
    window.location.replace('/login');
};
export const redirectToUnauthorized = () => {
    window.location.replace('/unauthorized');
};
